import * as _ from 'lodash';
import { IAdpDonorState } from "./state";

var initialState: IAdpDonorState = {
}

export const Reducer = (state: IAdpDonorState = initialState, action: any) => {
    let s = _.cloneDeep(state);
    return s;
}